

import { Grid } from "@mui/material";
import { DisenioGalpon } from "../../layout";
import { TarjetasOpciones } from "../../components";
import { useNavigate, useParams } from "react-router-dom";





export const OpcionesGalpon = () => {


    const { id } = useParams();
    const navigate = useNavigate();


    
    const handleNavegar = (url) => {
        navigate(`/admin/galpon/${id}/${url}`)
    }


    const data = [
        {key:1, titulo:'Editar Galpon', function: handleNavegar, url:'edit', icono:'setting'},
    ];


    return (

        <DisenioGalpon titulo="Opciones de Galpon">

            <Grid container spacing={3} sx={{mt:1}}>
                {data.map( item => (
                    <Grid key={item.key} item xs={6} sm={4} md={3} lg={2.4}>
                        <TarjetasOpciones 
                            onClickHandler={item.function} 
                            url={item.url} 
                            icono={item.icono} 
                            titulo={item.titulo} 
                        />
                    </Grid>
                ))}
            </Grid>

        </DisenioGalpon>

    )
}
